var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.prices, function (p, index) {
      return _c("div", { staticClass: "input-group" }, [
        _c("div", { staticClass: "input-group-prepend" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: p.qty,
                  expression: "p.qty",
                },
              ],
              staticClass: "form-control",
              staticStyle: { width: "44px" },
              attrs: { disabled: index === 0 },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.$set(
                    p,
                    "qty",
                    $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                  )
                },
              },
            },
            [
              index === 0
                ? [_c("option", { attrs: { value: "1" } }, [_vm._v("1")])]
                : _vm._l(_vm.getAllowedPriceQty(p.qty), function (qty) {
                    return _c("option", { domProps: { value: qty } }, [
                      _vm._v(_vm._s(qty)),
                    ])
                  }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: p.price,
              expression: "p.price",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "number" },
          domProps: { value: p.price },
          on: {
            change: _vm.updatePriceMargin,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(p, "price", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        !_vm.singlePrice
          ? _c(
              "div",
              { staticClass: "input-group-append" },
              [
                _c("span", { staticClass: "input-group-text" }, [
                  _c("strong", [_vm._v(_vm._s(p.margin) + " %")]),
                ]),
                _vm._v(" "),
                index === 0
                  ? [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary",
                          staticStyle: { width: "41px" },
                          attrs: { type: "button" },
                          on: { click: () => _vm.addNewPrice() },
                        },
                        [_vm._v("+\n        ")]
                      ),
                    ]
                  : [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-warning",
                          attrs: { type: "button" },
                          on: { click: () => _vm.addNewPrice(index) },
                        },
                        [
                          _c("i", {
                            staticClass: "icon-fa icon-fa-trash-o",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ],
              ],
              2
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }